// import React, { useEffect, useState } from "react"
// import Breadcrumbs from "../../../../components/Common/Breadcrumb"
// import { Container, Card, Row, Col, CardBody, Label } from "reactstrap"
// import { CKEditor } from "@ckeditor/ckeditor5-react"
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

// const InvoiceDetailIndex = () => {
//   const [details, setDetails] = useState({
//     address: "<p></p>",
//   })

//   const handleField = (name, value) =>
//     setDetails(prev => ({ ...prev, [name]: value }))

//   useEffect(() => {
//     document.title = "Invoice Details | Zithas Crm"
//   }, [])

//   return (
//     <React.Fragment>
//       <div className="page-content mb-4">
//         <Container fluid>
//           <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Invoice Details"} />
//           <Row>
//             <div className="col-7 ps-0">
//               <Card>
//                 <CardBody>
//                   {/* Address */}
//                   <div className="">
//                     <Label>
//                       Address <span className="text-danger">*</span>
//                     </Label>
//                     <textarea
//                       className="form-control"
//                       placeholder="Enter Address"
//                       onChange={e => handleField("address", e.target.value)}
//                     ></textarea>
//                   </div>

//                   {/* tnc */}
//                   <div className="mt-3">
//                     <Label>
//                       Terms & Conditions <span className="text-danger">*</span>
//                     </Label>
//                     <CKEditor
//                       editor={ClassicEditor}
//                       data={details.tnc}
//                       onChange={(_event, editor) =>
//                         handleField("tnc", editor.getData())
//                       }
//                     />
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>
//             <div className="col-5 pe-0">
//               <Card>
//                 <CardBody></CardBody>
//               </Card>
//             </div>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default InvoiceDetailIndex

import React, { useEffect } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import InvoiceDetailsForm from "./InvoiceDetailsForm"
import LutRecords from "./LutRecords"
import configure from "configure"

const InvoiceDetailIndex = () => {
  useEffect(() => {
    document.title = "Invoice Details | Zithas Crm"
  }, [])

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Invoice Details" />
          <div className="row align-items-start">
            <div className={`col-${configure.location.includes(1) ? '7' : '12 pe-0'} ps-0`}>
              <InvoiceDetailsForm />
            </div>
            {
              configure.location.includes(1) &&
              <div className="col-5 pe-0 position-sticky top-0 align-self-start">
                <LutRecords />
              </div>
            }
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default InvoiceDetailIndex
